import Vue from "vue";
import { etapaDoStatus, registrarTransicao } from "@/utilities/cronometroProcessamento";

const STORAGE_KEY = "processamentosArquivos";
const INTERVALO_POLLING_MS = 6000;

const TIPOS = {
    Prestamista: "ProcessamentoPrestamista",
    SQG: "ProcessamentoSQG",
    DFI: "ProcessamentoDFI",
};

function carregarAtivos() {
    try {
        const bruto = localStorage.getItem(STORAGE_KEY);
        if (!bruto || bruto === "undefined") return [];
        const lista = JSON.parse(bruto);
        return Array.isArray(lista) ? lista : [];
    } catch (e) {
        return [];
    }
}

function persistir(ativos) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ativos));
    } catch (e) {
        return;
    }
}

const state = {
    ativos: carregarAtivos(),
    pollingHandle: null,
};

const mutations = {
    adicionar(state, item) {
        state.ativos = [
            ...state.ativos.filter((p) => !(p.tipo === item.tipo && p.idProcessamento === item.idProcessamento)),
            item,
        ];
        persistir(state.ativos);
    },
    atualizar(state, { tipo, idProcessamento, dados }) {
        state.ativos = state.ativos.map((p) =>
            p.tipo === tipo && p.idProcessamento === idProcessamento ? { ...p, ...dados } : p
        );
        persistir(state.ativos);
    },
    remover(state, { tipo, idProcessamento }) {
        state.ativos = state.ativos.filter((p) => !(p.tipo === tipo && p.idProcessamento === idProcessamento));
        persistir(state.ativos);
    },
    setPollingHandle(state, handle) {
        state.pollingHandle = handle;
    },
};

const actions = {
    iniciar({ commit, dispatch }, { tipo, idProcessamento, competencia }) {
        commit("adicionar", {
            tipo,
            idProcessamento,
            competencia,
            status: "Na Fila",
            statusEmail: null,
            tentativasEnvioEmail: 0,
            podeBaixarExcel: false,
            mensagemErro: null,
            finalizado: false,
            dataInicio: new Date().toISOString(),
            tempos: registrarTransicao({}, null, "fila", Date.now()),
        });
        dispatch("garantirPolling");
    },

    garantirPolling({ state, dispatch }) {
        if (state.pollingHandle) return;
        dispatch("verificarTodos");
        state.pollingHandle = setInterval(() => dispatch("verificarTodos"), INTERVALO_POLLING_MS);
    },

    async verificarTodos({ state, commit, dispatch }) {
        const pendentes = state.ativos.filter((p) => !p.finalizado);
        if (pendentes.length === 0) {
            if (state.pollingHandle) {
                clearInterval(state.pollingHandle);
                commit("setPollingHandle", null);
            }
            return;
        }

        for (const item of pendentes) {
            await dispatch("verificarUm", item);
        }
    },

    async verificarUm({ commit }, item) {
        const endpoint = TIPOS[item.tipo];
        if (!endpoint) return;

        try {
            const res = await Vue.prototype.$httpPortal.get(`${endpoint}/Status/${item.idProcessamento}`);
            if (!res || !res.data || !res.data.success) return;

            const payload = res.data.data || {};

            const finalizado =
                payload.status === "Erro" ||
                (payload.status === "Concluído" &&
                    (payload.statusEmail == null || payload.statusEmail === "Enviado" || payload.statusEmail === "Erro"));

            const etapaAnterior = etapaDoStatus(item.status, item.statusEmail);
            const etapaNova = etapaDoStatus(payload.status, payload.statusEmail);
            const tempos =
                etapaAnterior !== etapaNova
                    ? registrarTransicao(item.tempos, etapaAnterior, etapaNova, Date.now())
                    : item.tempos;

            commit("atualizar", {
                tipo: item.tipo,
                idProcessamento: item.idProcessamento,
                dados: {
                    status: payload.status,
                    statusEmail: payload.statusEmail || null,
                    tentativasEnvioEmail: payload.tentativasEnvioEmail || 0,
                    podeBaixarExcel: !!payload.podeBaixarExcel,
                    mensagemErro: payload.mensagemErro || null,
                    finalizado,
                    tempos,
                },
            });
        } catch (e) {
            return;
        }
    },

    remover({ commit }, { tipo, idProcessamento }) {
        commit("remover", { tipo, idProcessamento });
    },
};

const getters = {
    ativos: (state) => state.ativos,
    quantidadeEmAndamento: (state) => state.ativos.filter((p) => !p.finalizado).length,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
